"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadMomentFooter = void 0;

var _reactCircularProgressbar = require("react-circular-progressbar");

var _atoms = require("../../../atoms");

require("react-circular-progressbar/dist/styles.css");

var _Tracker = require("../../../util/Tracker");

var _molecules = require("../../../molecules");

require("./UploadMomentFooter.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Upload Moment Footer
var UploadMomentFooter = function UploadMomentFooter(_ref) {
  var buttonTitle = _ref.buttonTitle,
      buttonDisabled = _ref.buttonDisabled,
      onButtonClick = _ref.onButtonClick,
      onDisabledButtonClick = _ref.onDisabledButtonClick,
      uploading = _ref.uploading,
      uploadingProgress = _ref.uploadingProgress,
      message = _ref.message,
      showButtonIcon = _ref.showButtonIcon,
      hideButton = _ref.hideButton;

  var handleOnButtonClick = function handleOnButtonClick(e) {
    if (typeof onButtonClick === "function") {
      (0, _Tracker.trackEvent)({
        action: "Step Button ".concat(buttonTitle, " Pressed"),
        element: e.currentTarget
      });
      onButtonClick();
    }
  };

  var handleOnDisabledButtonClick = function handleOnDisabledButtonClick(e) {
    if (typeof onDisabledButtonClick === "function") {
      (0, _Tracker.trackEvent)({
        action: "Step Button ".concat(buttonTitle, " (Disabled) Pressed"),
        element: e.currentTarget
      });
      onDisabledButtonClick();
    }
  };

  var progress = uploadingProgress / 200 * 100;
  var messageTitle = message ? message.title : null;
  var messageType = message ? message.type : null;
  var messageCn = messageType ? "upload-moment-controls-footer-inner-message ".concat(messageType) : 'upload-moment-controls-footer-inner-message';
  var uploadProgressContainerCn = hideButton ? "upload-progress-container hide-button" : "upload-progress-container";
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "FooterSection UploadMomentFooter"
  }, message && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: messageCn,
    padding: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true
  }, messageTitle)), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    justifyContent: "center",
    className: "upload-moment-controls-footer-inner"
  }, uploading && uploadingProgress !== 200 && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    alignItems: "center",
    justifyContent: "center",
    className: uploadProgressContainerCn
  }, /*#__PURE__*/_react.default.createElement(_reactCircularProgressbar.CircularProgressbar, {
    value: progress,
    strokeWidth: 12,
    styles: (0, _reactCircularProgressbar.buildStyles)({
      pathColor: '#7ED321',
      trailColor: '#CACCCC'
    })
  })), !hideButton && buttonDisabled && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: true,
    onClick: handleOnDisabledButtonClick,
    className: "disabled",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: buttonTitle,
      marginRight: "2"
    }), showButtonIcon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.CheveronRight
    }))
  }), !hideButton && !buttonDisabled && /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: true,
    onClick: handleOnButtonClick,
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: buttonTitle,
      marginRight: "2"
    }), showButtonIcon && /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: 16,
      type: _atoms.Icon.Type.CheveronRight
    }))
  })));
};

exports.UploadMomentFooter = UploadMomentFooter;
UploadMomentFooter.defaultProps = {
  buttonDisabled: false,
  showButtonIcon: true,
  hideButton: false
};